// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const RecentPurchases: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h32v32H0z" />
                <g stroke="currentColor">
                    <path d="M7.727 4h13.132v24l-2.81-1.588L15.239 28l-2.81-1.588L9.62 28l-2.81-1.588L4 28V7.81C4 5.704 5.669 4 7.727 4ZM20.859 4h3.414C26.331 4 28 5.705 28 7.81v12.748h-7.141V4ZM6.81 18.96h8.649M6.81 15.209h11.239M6.81 22.711h11.239M6.81 11.458h8.649M6.81 7.706h11.239" />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(RecentPurchases);
